import { Component, OnInit, Input } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';

import { environment } from '@app/env-service';

@Component({
  selector: 'cnc-attachments-view',
  templateUrl: './attachments-view.component.html',
  styleUrls: ['./attachments-view.component.scss'],
})
export class AttachmentsViewComponent implements OnInit {
  url :string = environment.url;

  @Input() attachments :any;

  constructor(private _lightbox :Lightbox) {}

  ngOnInit() {}

  open(index :number) :void {
    // open lightbox
    const images :any = [];
    this.attachments.forEach((row :any) => {
      if (row.filetype && row.filetype.includes('image')) {
        images.push({
          src: this.url + '/file?f=' + row.filename,
          caption: row.remarks || row.fileurl,
          thumb: this.url + '/file?f=' + row.thumburl,
        });
      }
    });

    this._lightbox.open(images, index);
  }
}
